import { render, staticRenderFns } from "./CustomStatusModal.vue?vue&type=template&id=f815af12&scoped=true"
import script from "./CustomStatusModal.vue?vue&type=script&lang=js"
export * from "./CustomStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f815af12",
  null
  
)

export default component.exports